<div class="col-8 offset-2">
  <div class="row">
    <div class="col-12">
        <div class="alert alert-info text-center">
            <h4 class="alert-heading">Cargando</h4>
            <i class="fa fa-sync fa-spin fa-3x"></i>
            <p class="mb-0">Espera por favor...</p>
        </div>
    </div>
  </div>
</div>
